<template>
  <mock-up-main>
    <template v-if="!showModal" v-slot:menu>
      <div style="position: absolute; width: 100%" class="navbar w-100">
        <b-app-bar v-model="showModal" :logo="logo" />
      </div>
    </template>
    <div
      v-if="loading"
      class="fill-height d-flex align-center justify-center white"
      style="position: absolute; inset: 0; z-index: 10"
    >
      <v-progress-circular color="primary" height="5" indeterminate />
    </div>
        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کیوآر سایت مجتمع تجاری/اداری'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <div v-if="!showModal" style="position: relative">
      <!-- bannerSection -->
      <b-intro-slider-view
        v-if="value"
        v-model="computedBanner"
        :is-slider="false"
      />
      <!-- bannerSection -->

      <!-- servicesSection -->
      <b-service-view
        v-if="hasServices"
        v-model="value.service"
        :description="value.Service.description"
        :style="{
          background: value.Service.sectionColor.backGround,
          color: value.Service.sectionColor.text,
        }"
        :color="value.Service.sectionColor.text"
        :title="value.Service.title"
        type="icon"
      />
      <!-- servicesSection -->
      <b-show-floors
        v-if="value?.floor?.floors?.length > 0"
        v-model="value.floor"
        :title="value.Floor"
        type="floor"
      />
      <!-- faqection -->
      <b-faq-view
        v-if="!!value.faq && !!value.faq.items.length"
        v-model="value.faq"
        :style="{
          background: value.faq.sectionColor.backGround,
          color: value.faq.sectionColor.text,
        }"
      />
      <!-- faqection -->

      <!-- gallerySection -->
      <gallery-slider
        v-if="value.PicSelector && hasGallery && value.PicSelector.slider"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
      />

      <b-gallery-view
        v-else-if="value.PicSelector && hasGallery"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :is-img="true"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
        is-grid
        new-position
      />
      <!-- gallerySection -->

      <!-- VideogallerySection -->
      <b-gallery-view
        v-if="
          value.video_gallery?.length > 0 &&
          value.video_gallery?.filter((item) => item.images?.length > 0)
            ?.length > 0 &&
          value.VideoGallery &&
          value.video_gallery &&
          !value.VideoGallery.slider &&
          value.VideoGallery.sectionColor
        "
        v-model="value.video_gallery"
        :description="value.VideoGallery.description"
        :is-img="false"
        :style="{
          background: value.VideoGallery.sectionColor.backGround,
          color: value.VideoGallery.sectionColor.text,
        }"
        :title="value.VideoGallery.title"
        type="video_gallery"
      />
      <!-- VideogallerySection -->

      <!-- pdfSection -->
      <div v-if="value.pdf && value.pdf.length > 0">
        <pdf-preview-display
          :pdf-data="value.pdf"
          :layout-mode="layoutPreference"
          :pdf-selector="value.pdfSelector"
          :style="{
            background: value.pdfSelector.sectionColor.backGround,
            color: value.pdfSelector.sectionColor.text,
          }"
        />
      </div>
      <!-- <b-gallery-view
        v-if="value.pdfSelector && value.pdf && !value.pdfSelector.slider"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :is-img="true"
        :style="{
          background: value.pdfSelector.sectionColor.backGround,
          color: value.pdfSelector.sectionColor.text,
        }"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- gallerySection -->

      <!-- <gallery-slider
        v-else-if="value.pdfSelector && !!value.pdf"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- pdfSection -->

      <b-blog-view
        v-if="hasBlog"
        v-model="value.blog"
        :description="value.Blog.description"
        :style="{
          background: value.Blog.sectionColor.backGround,
          color: value.Blog.sectionColor.text,
        }"
        :bstyle="value.Blog.sectionColor"
        :title="value.Blog.title"
        :type="value.Blog.slider ? 'slider' : 'default'"
      />

      <ads-components
        v-if="
          !!value.Product &&
          !!value.Product.items &&
          value.Product.items.length > 0
        "
        v-model="value.Product"
      />

      <b-section-view
        v-if="value.ServiceSection && value.ServiceSection.items.length > 0"
        v-model="value.ServiceSection"
      />

      <b-feedback-view
        v-if="value.FeedBack && value.FeedBack.items.length > 0"
        v-model="value.FeedBack"
      />

      <b-testimonials-view
        v-if="value.CounterService && value.CounterService.items.length > 0"
        v-model="value.CounterService"
      />

      <!-- <forms-ui
        v-if="
          value.consultation &&
          value.consultation.items &&
          Object.values(value.consultation.items).filter(
            (item) => item.is_active
          ).length > 0
        "
        v-model="value.consultation.items"
        :description="value.consultation.description"
        :style="{
          background: value.consultation.sectionColor.backGround,
          color: value.consultation.sectionColor.text,
        }"
        :title="value.consultation.title"
      /> -->

      <consultation-new-show
        :style="{
          background: value.consultationNew.sectionColor.backGround,
          color: value.consultationNew.sectionColor.text,
        }"
        v-model="value.consultationNew"
      />

      <team-ui
        v-if="
          !!value.Personnel &&
          !!value.Personnel.items &&
          !!value.Personnel.items.length
        "
        v-model="value.Personnel"
      />

      <count-down
        v-if="value.Counter && value.Counter.until"
        v-model="value.Counter.until"
        :description="value.Counter.description"
        :title="value.Counter.title"
      />

      <b-footer-view
        v-if="value.textCards"
        v-model="value"
        :style="{
          background: value.textCards.sectionColor.backGround,
          color: value.textCards.sectionColor.text,
        }"
        class="mt-10"
      />
    </div>

    <template v-if="!showModal" v-slot:extension>
      <div style="position: absolute; left: 20%; bottom: 10%; z-index: 5">
        <b-action
          :pallete="value?.pallete"
          :phon.sync="value.companyNumber"
          :map.sync="map"
          @getVcf="getVcf"
        />
      </div>
    </template>

    <template v-slot:dialog v-if="showModal">
      <v-card
        style="
          margin: 11px 1rem !important;
          left: 0px;
          width: 94%;
          position: absolute;
          top: 4%;
          z-index: 0;
          padding: 0px 0rem;
          right: 0px;
          height: auto;
          border-radius: 10px;
          bottom: 7%;
          overflow-y: auto;
        "
        class="search-dialog-card"
        color="white"
      >
        <v-toolbar
          dark
          :color="value?.pallete?.headColor?.length > 0 ? null : 'primary'"
          :style="{
            background:
              value?.pallete?.headColor?.length > 0
                ? value?.pallete?.headColor
                : '',
          }"
          class="w-100"
          flat
        >
          <v-btn icon @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="headline">جستجوی فروشگاه‌ها</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchInput"
            append-icon="mdi-magnify"
            solo
            autofocus
            flat
            hide-details
            clearable
            placeholder="نام فروشگاه، دسته‌بندی یا کلیدواژه‌ها را وارد کنید..."
            class="search-input"
          />
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-row dense>
            <template v-if="searchItems && searchItems.length > 0">
              <v-col
                cols="12"
                style="height: auto; overflow-y: auto"
                v-for="(shop, i) in searchItems"
                :key="shop.id || i"
              >
                <b-floor-shop :shopDetails="shop" class="shop-card" />
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" class="text-center my-12">
                <v-icon color="grey lighten-1" size="64"
                  >mdi-store-alert-outline</v-icon
                >
                <h3 class="subtitle-1 grey--text mt-3">
                  متاسفانه فروشگاهی با این مشخصات یافت نشد.
                </h3>
                <p class="caption grey--text">
                  لطفاً عبارت جستجو را تغییر دهید یا از کلیدواژه‌های عمومی‌تر
                  استفاده کنید.
                </p>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

    <template v-slot:map v-if="map && !showModal">
      <v-card
        v-if="value.coordinates"
        color="#c4c0c0"
        style="
          margin: 11px 1rem !important;
          left: 0px;
          width: 94%;
          position: absolute;
          top: 4%;
          z-index: 5;
          padding: 0px 1rem;
          right: 0px;
          height: 84%;
          border-radius: 10px;
        "
        class="pa-2"
      >
        <v-card-title class="px-0 pt-4 justify-end">
          <v-btn
            class="mr-auto w-100 text-left"
            :color="value.pallete.headColor.length > 0 ? null : 'primary'"
            :style="{
              background:
                value?.pallete?.headColor?.length > 0
                  ? value.pallete.headColor
                  : '',
            }"
            small
            @click="map = false"
          >
            بستن نقشه
          </v-btn>
        </v-card-title>
        <map-show v-if="map" v-model="value" />
      </v-card>
    </template>
  </mock-up-main>
</template>

<script>
import BIntroSliderView from "./bIntroSliderView";
import BFooterView from "./bFooterView";
import BFaqView from "./bFaqView";
import BGalleryView from "./bGalleryView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import BServiceView from "./bServiceView";
import BBlogView from "./bBlogView";
import BFeedbackView from "./bFeedbackView";
import MockUpMain from "../mockUp.vue";
import FormsUi from "@/view/components/formsUi";
import BTestimonialsView from "./bTestimonialsView";
import BSectionView from "./bSectionView";
import teamUi from "../../../../components/Personnel/teamUi.vue";
import CountDown from "@/view/pages/businessPage/pages/shopPage/components/countDown";
import axios from "axios";
import AdsComponents from "@/view/components/Product/AdsComponents";
import bShowFloors from "./bShowFloors.vue";
import bAppBar from "./bAppBar.vue";
import bFloorShop from "../cm/bFloorShop.vue";
import bAction from "../cm/bAction.vue";
import MapShow from "@/view/components/Product/mapShow";
import consultationNewShow from "../../../../components/consultationNew/consultationNewShow.vue";
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplay";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "commericalPage",

  components: {
    AdsComponents,
    PdfPreviewDisplay,
    teamUi,
    CountDown,
    BSectionView,
    FormsUi,
    BTestimonialsView,
    MockUpMain,
    BFeedbackView,
    BServiceView,
    BGalleryView,
    BFaqView,
    BFooterView,
    BIntroSliderView,
    GallerySlider,
    BBlogView,
    bShowFloors,
    bAppBar,
    bFloorShop,
    bAction,
    MapShow,
    consultationNewShow,
    UniversalQrModal
  },

  props: {
    value: Object,
    loading: Boolean,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  watch: {
    value: {
      deep: true,

      handler() {
        this.$forceUpdate();
      },
    },
    searchInput(val) {
      if (val.length > 0) {
        this.findSearch(val);
      } else {
        this.searchItems = [];
      }
    },
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },

    hasGallery() {
      return (
        this.value.gallery?.length > 0 &&
        this.value.gallery?.filter((item) => item.images?.length > 0)?.length >
          0
      );
    },
    hasServices() {
      return (
        !!this.value.service?.length &&
        !!this.value.service.filter(
          (item) =>
            !!item.content ||
            (!!item.gallery?.length && !!item.gallery[0].images.length),
        ).length
      );
    },

    hasBlog() {
      return (
        !!this.value.blog?.length &&
        !!this.value.blog.filter(
          (item) =>
            !!item.content ||
            (!!item.gallery?.length && !!item.gallery[0].images.length),
        ).length
      );
    },
    computedBanner() {
      if (this.value?.banner?.gallery && this.value.banner.gallery[0])
        return {
          banner: this.value.banner.gallery[0],
        };
      else {
        return null;
      }
    },
    logo() {
      return this.value.logo?.gallery[0].images[0]?.url ?? false;
    },
  },

  data() {
    return {
      showQrDialog: false,
      showModal: false,
      searchInput: "",
      searchItems: [],
      phon: false,
      map: false,
    };
  },

  methods: {
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.visitName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
    findSearch(search) {
      let find = this.value.floor.shops
        .map((item) => {
          const matchingTags = item.tags
            ? item?.tags.filter((tag) => tag.includes(search))
            : [];
          if (
            item?.subtitle?.includes(search) ||
            item?.title?.includes(search) ||
            item?.setting?.name.includes(search) ||
            matchingTags.length > 0
          ) {
            // برگردون کل آیتم به همراه فقط تگ‌های مطابق
            return {
              ...item,
              ...matchingTags,
            };
          }
          return null;
        })
        .filter((item) => item);

      this.searchItems = find;
    },
  },
};
</script>

<style scoped>
.sad {
  border-radius: 100%;
}

.fixed-action {
  z-index: 99;
  position: fixed;
  bottom: 5%;
  left: 7%;
}

.navbar {
  display: flex;
  padding: 6px 1rem !important;
  position: absolute !important;
  justify-content: center !important;
  align-content: center;
  top: 5%;
  right: 0;
  width: 100%;
  z-index: 4;
}

.v-dialog__content {
  position: absolute !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 5;
}

.v-dialog__content >>> .v-dialog {
  height: 80%;
  margin: 13px !important;
}

.v-overlay >>> .v-overlay__scrim {
  background: transparent !important;
}

.v-dialog__content >>> .v-dialog .search-dialog-card {
  min-height: 0;
  background-color: transparent;
}
/* .v-dialog >>> .search-dialog-card {
  height: 85%;
} */

/* When the screen width is smaller than 600px */
@media (max-width: 600px) {
  .fixed-action {
    left: 20%; /* Adjust the position for small screens */
  }
}
.qr-floating-btn {
  position: absolute;
  top: 144px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
